import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import React from 'react';
import Home from "../../Assets/Images/sampleChart.png";
import LeadershipChart from '../Charts/LeadershipChart';
import Header from '../../Components/GeneratePdf/Header';
import Footer from '../../Components/GeneratePdf/Footer';

const styles = StyleSheet.create({
  page: {
    paddingHorizontal: 21,
    paddingVertical: 15,
    backgroundColor: '#FFFFFF',
    height: '100%'
  },
  justifystyle: {
    justifyContent: 'space-between',
    height: 680
  },
  section: {
    marginVertical: 5,
  },
  pageheading: {
    color: '#426B88',
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: 18,
    marginBottom: 10
  },
  paragraph: {
    fontSize: 12,
    textAlign: 'justify',
    fontWeight: 400,
    color: '#245775',
    marginBottom: 15,
    fontFamily: 'Lato',
  },
  secondsection: {
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Lato",
  },
  subtitle: {
    fontSize: 18,
    lineHeight: 25,
    fontFamily: "Lato",
    fontWeight: "700",
    color: "#426B88",
    justifyContent: "center",
    marginBottom: 5,
  },
  chartcontainer: {
    padding: 2,
    marginTop: -5,
    width: "100%",
    alignItems: "center",
  },
  header: {
    flexDirection: "row",
    justifyContent: "center",
    marginBottom: 2,
    width: "100%",
  },
  title: {
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 35,
    color: "#426B88",
    fontFamily: "Lato",
    marginHorizontal: 60,
  },
  imageContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center", 
    width: "100%",
    marginHorizontal: 0,
    paddingHorizontal: 10,
  },
  separator: {
    width: 1, 
    height: 180,
    backgroundColor: "#000000",
    marginHorizontal: 5, 
  },
});

const LeadershipStyleChart360 = () => {
  const quadrants = [
    { label: 'Strategic', value: 29, color: '#4A6FA5' },
    { label: 'Performance', value: 14, color: '#E0A458' },
    { label: 'Visionary', value: 22, color: '#3D85C6' },
    { label: 'Collaborative', value: 35, color: '#D9534F' },
  ];

  return (
    <Page size="A4" style={styles.page}>
      {/* Header */}
      <Header/>

      <View style={styles.justifystyle}>
        {/* Content */}
        <View style={styles.section}>
          <Text style={styles.pageheading}>LEADERSHIP STYLE</Text>
          <Text style={styles.paragraph}>
            Quadrant Flow not only delineates your predominant leadership style,
            but it also provides a comprehensive framework for personal and
            professional growth. By understanding the distinct functions and
            attributes associated with each quadrant, leaders are equipped to
            enhance their self-awareness and adapt their approach to various
            situations.
          </Text>
          <Text style={styles.paragraph}>
            This methodology encourages leaders to explore how their unique
            attributes can be harmonized to maximize effectiveness, foster
            better team dynamics, and achieve organizational objectives. The
            holistic perspective offered by Quadrant Flow enables a deeper
            introspection into how one's leadership style impacts their
            environment, thereby facilitating a more balanced and strategic
            approach to leadership challenges.
          </Text>
          <Text style={styles.paragraph}>
            This exploration goes beyond merely identifying a primary leadership
            style; it involves examining the alignment—or potential
            misalignment—between your natural tendencies and the Quadrant Flow
            framework. Such an overlay offers valuable insights into the nuances
            of your leadership approach, revealing areas of strength as well as
            opportunities for improvement.
          </Text>
          <Text style={styles.paragraph}>
            By understanding where gaps exist between your current practices and
            the ideal quadrant attributes, you can initiate targeted development
            efforts. The goal is to foster a journey of continuous growth, where
            leaders not only understand who they are but also how they can
            evolve within the context of their roles and responsibilities.
          </Text>
        </View>

        {/* Graph */}
        <View style={styles.secondsection}>
          <Text style={styles.subtitle}>LEADERSHIP STYLE OVERVIEW CHART</Text>
          <View style={styles.chartcontainer}>
            <View style={styles.header}>
              <Text style={styles.title}>SELF</Text>
              <Text style={styles.title}>360</Text>
            </View>
            <View style={styles.imageContainer}>
              <LeadershipChart/>
              <View style={styles.separator} />
              <LeadershipChart/>
            </View>
          </View>
        </View>
      </View>

      {/* Footer Section */}
      <Footer/>
    </Page>
  );
};

export default LeadershipStyleChart360;